import * as actionType from "./ActionTypes";
import { filter } from "lodash";

export default function TransporterReducers(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.TRANSPORTER_LOADING:
      return (state = payload);
    case actionType.TRANSPORTER_DELETE_ROW:
      for (let i = 0; i < payload.deleteIdPayload.length; i++) {
        state = filter(state, function (datas) {
          return datas.TransporterDataId !== parseInt(payload.deleteIdPayload[i]);
        });
      }
      // if(state.length === 0){
        payload.statePayload(state)
      // }
      return state;
    default:
      return state;
  }
}
